const ACTIONS = [
  'WEB_ACCESS',
  'ORDERS_SUMMARY_VIEW',
  'ORDERS_VIEW',
  'ORDERS_ASSIGN',
  'ORDERS_ASSIGN_PRICE_VIEW',
  'ORDERS_CANCEL',
  'ORDERS_COMPLETE',
  'ORDERS_DETAIL_VIEW',
  'ORDER_REPORTS_VIEW',
  'ORDER_REPORTS_RESOLVE',
  'SCHEDULE_VIEW',
  'PARAMETER_VIEW',
  'PARAMETER_UPDATE',
  'BASP_VIEW',
  'BASP_CREATE',
  'BASP_UPDATE',
  'CUSTOMERS_VIEW',
  'CUSTOMERS_CREATE',
  'CUSTOMERS_EDIT',
  'TRANSPORTERS_VIEW',
  'TRANSPORTERS_CREATE',
  'TRANSPORTERS_EDIT',
  'CLIENT_COMPANYPROFILE_VIEW',
  'CLIENT_COMPANYPROFILE_UPDATE',
  'CLIENT_COMPANYCONTRACTDETAIL_VIEW',
  'CLIENT_COMPANYCONTRACTDETAIL_UPDATE',
  'CLIENT_ADMINS_VIEW',
  'CLIENT_ADMINS_UPDATE',
  'CLIENT_LOCATIONSVEHICLES_VIEW',
  'CLIENT_LOCATIONSVEHICLES_UPDATE',
  'CLIENT_PRICE_VIEW',
  'CLIENT_PRICE_UPDATE',
  'TRANSPORT_TYPES_VIEW',
  'TRANSPORT_TYPES_CREATE',
  'TRANSPORT_TYPES_EDIT',
  'CATEGORIES_VIEW',
  'CATEGORIES_CREATE',
  'CATEGORIES_EDIT',
  'LOCATIONS_VIEW',
  'LOCATIONS_CREATE',
  'LOCATIONS_EDIT',
  'ADDITIONALCOSTS_VIEW',
  'ADDITIONALCOSTS_CREATE',
  'ADDITIONALCOSTS_EDIT',
  'SELECTIONITEMS_VIEW',
  'SELECTIONITEMS_CREATE',
  'SELECTIONITEMS_EDIT',
  'INVOICE_VIEW',
  'INVOICE_CREATE',
  'INVOICE_UPDATE',
  'ORDERS_CALCULATE_UNIT',
  'USERADMINS_VIEW',
  'USERADMINS_CREATE',
  'USERADMINS_EDIT',
  'ORDERS_UPDATE_MAIN_PRICE',
  'ORDERS_UPDATE_MAIN_PRICE_UNIT',
  'ORDERS_UPDATE_ADDITIONAL_PRICE',
  'ORDERS_UPDATE_DOCUMENTS',
  'INVOICE_PRINT',
  'INVOICE_PROFORMA_EMAIL',
  'INVOICE_PROFORMA_DOWNLOAD_CSV',
  'TAX_VIEW',
  'INVOICEDATA_VIEW',
  'INVOICEDATA_EDIT',
  'REPORTS_OPERATIONAL',
  'REPORTS_FINANCE'
]

const SUPER_ADMIN = [
  ...ACTIONS
]

const MARKETING_SPV = [
  'WEB_ACCESS',
  'ORDERS_SUMMARY_VIEW',
  'ORDERS_VIEW',
  'ORDERS_ASSIGN',
  'ORDERS_ASSIGN_PRICE_VIEW',
  'ORDERS_DETAIL_VIEW',
  'ORDER_REPORTS_VIEW',
  'ORDER_REPORTS_RESOLVE',
  'SCHEDULE_VIEW',
  'PARAMETER_VIEW',
  'PARAMETER_UPDATE',
  'BASP_VIEW',
  'BASP_CREATE',
  'BASP_UPDATE',
  'CUSTOMERS_VIEW',
  'CUSTOMERS_CREATE',
  'CUSTOMERS_EDIT',
  'TRANSPORTERS_VIEW',
  'TRANSPORTERS_CREATE',
  'TRANSPORTERS_EDIT',
  'CLIENT_COMPANYPROFILE_VIEW',
  'CLIENT_COMPANYPROFILE_UPDATE',
  'CLIENT_COMPANYCONTRACTDETAIL_VIEW',
  'CLIENT_COMPANYCONTRACTDETAIL_UPDATE',
  'CLIENT_ADMINS_VIEW',
  'CLIENT_ADMINS_UPDATE',
  'CLIENT_LOCATIONSVEHICLES_VIEW',
  'CLIENT_LOCATIONSVEHICLES_UPDATE',
  'CLIENT_PRICE_VIEW',
  'CLIENT_PRICE_UPDATE',
  'TRANSPORT_TYPES_VIEW',
  'TRANSPORT_TYPES_CREATE',
  'TRANSPORT_TYPES_EDIT',
  'CATEGORIES_VIEW',
  'CATEGORIES_CREATE',
  'CATEGORIES_EDIT',
  'LOCATIONS_VIEW',
  'LOCATIONS_CREATE',
  'LOCATIONS_EDIT',
  'ADDITIONALCOSTS_VIEW',
  'ADDITIONALCOSTS_CREATE',
  'ADDITIONALCOSTS_EDIT',
  'SELECTIONITEMS_VIEW',
  'SELECTIONITEMS_CREATE',
  'SELECTIONITEMS_EDIT',
  'INVOICE_VIEW',
  'ORDERS_CALCULATE_UNIT',
  'REPORTS_OPERATIONAL',
  'REPORTS_FINANCE'
]
const LOGISTIC_ADMIN = [
  'WEB_ACCESS',
  'ORDERS_SUMMARY_VIEW',
  'ORDERS_VIEW',
  'ORDERS_ASSIGN',
  'ORDERS_DETAIL_VIEW',
  'ORDER_REPORTS_VIEW',
  'ORDER_REPORTS_RESOLVE',
  'SCHEDULE_VIEW',
  'PARAMETER_VIEW',
  'PARAMETER_UPDATE',
  'BASP_VIEW',
  'BASP_CREATE',
  'BASP_UPDATE',
  'CUSTOMERS_VIEW',
  'TRANSPORTERS_VIEW',
  'TRANSPORT_TYPES_VIEW',
  'CATEGORIES_VIEW',
  'LOCATIONS_VIEW',
  'LOCATIONS_CREATE',
  'LOCATIONS_EDIT',
  'ADDITIONALCOSTS_VIEW',
  'SELECTIONITEMS_VIEW',
  'SELECTIONITEMS_CREATE',
  'SELECTIONITEMS_EDIT',
  'ORDERS_CALCULATE_UNIT',
  'REPORTS_OPERATIONAL',
]
const FAA_SPV = [
  'WEB_ACCESS',
  'ORDERS_SUMMARY_VIEW',
  'ORDERS_VIEW',
  'ORDERS_DETAIL_VIEW',
  'ORDER_REPORTS_VIEW',
  'ORDER_REPORTS_RESOLVE',
  'SCHEDULE_VIEW',
  'PARAMETER_VIEW',
  'PARAMETER_UPDATE',
  'BASP_VIEW',
  'BASP_CREATE',
  'BASP_UPDATE',
  'CUSTOMERS_VIEW',
  'CUSTOMERS_CREATE',
  'CUSTOMERS_EDIT',
  'TRANSPORTERS_VIEW',
  'TRANSPORTERS_CREATE',
  'TRANSPORTERS_EDIT',
  'CLIENT_PRICE_VIEW',
  'TRANSPORT_TYPES_VIEW',
  'LOCATIONS_VIEW',
  'ADDITIONALCOSTS_VIEW',
  'ADDITIONALCOSTS_CREATE',
  'ADDITIONALCOSTS_EDIT',
  'SELECTIONITEMS_VIEW',
  'INVOICE_VIEW',
  'INVOICE_CREATE',
  'INVOICE_PRINT',
  'INVOICE_PROFORMA_EMAIL',
  'INVOICE_PROFORMA_DOWNLOAD_CSV',
  'ORDERS_UPDATE_MAIN_PRICE',
  'ORDERS_UPDATE_MAIN_PRICE_UNIT',
  'ORDERS_UPDATE_ADDITIONAL_PRICE',
  'ORDERS_CALCULATE_UNIT',
  'ORDERS_UPDATE_DOCUMENTS',
  'TAX_VIEW',
  'CLIENT_PRICE_VIEW',
  'INVOICEDATA_VIEW',
  'INVOICEDATA_EDIT',
  'REPORTS_OPERATIONAL',
  'REPORTS_FINANCE'
]
const FAA_ADMIN = [
  'WEB_ACCESS',
  'ORDERS_SUMMARY_VIEW',
  'ORDERS_VIEW',
  'ORDERS_DETAIL_VIEW',
  'ORDER_REPORTS_VIEW',
  'ORDER_REPORTS_RESOLVE',
  'SCHEDULE_VIEW',
  'PARAMETER_VIEW',
  'PARAMETER_UPDATE',
  'BASP_VIEW',
  'BASP_CREATE',
  'BASP_UPDATE',
  'CUSTOMERS_VIEW',
  'TRANSPORTERS_VIEW',
  'TRANSPORT_TYPES_VIEW',
  'LOCATIONS_VIEW',
  'ADDITIONALCOSTS_VIEW',
  'ADDITIONALCOSTS_CREATE',
  'SELECTIONITEMS_VIEW',
  'INVOICE_VIEW',
  'INVOICE_CREATE',
  'INVOICE_PRINT_ONCE',
  'INVOICE_PROFORMA_EMAIL',
  'INVOICE_PROFORMA_DOWNLOAD_CSV',
  'ORDERS_UPDATE_MAIN_PRICE_UNIT',
  'ORDERS_UPDATE_ADDITIONAL_PRICE',
  'ORDERS_CALCULATE_UNIT',
  'ORDERS_UPDATE_DOCUMENTS',
  'TAX_VIEW',
  'INVOICEDATA_VIEW',
  'INVOICEDATA_EDIT',
  'REPORTS_OPERATIONAL',
  'REPORTS_FINANCE'
]
const MONITORING = [
  'WEB_ACCESS',
  'ORDERS_SUMMARY_VIEW',
  'ORDERS_VIEW',
  'ORDERS_DETAIL_VIEW',
  'ORDER_REPORTS_VIEW',
  'ORDER_REPORTS_RESOLVE',
  'SCHEDULE_VIEW',
  'TRANSPORTERS_VIEW',
  'TRANSPORT_TYPES_VIEW',
  'LOCATIONS_VIEW',
  'SELECTIONITEMS_VIEW',
  'ORDERS_CALCULATE_UNIT',
]

const ADMIN_POD = [
  'WEB_ACCESS',
  'ORDERS_SUMMARY_VIEW',
  'ORDERS_VIEW',
  'ORDERS_COMPLETE',
  'ORDERS_DETAIL_VIEW',
  'ORDERS_CALCULATE_UNIT',
  'ORDERS_UPDATE_DOCUMENTS',
]

export default {
  SUPER_ADMIN,
  MARKETING_SPV,
  LOGISTIC_ADMIN,
  FAA_SPV,
  FAA_ADMIN,
  MONITORING,
  ADMIN_POD,
}
